import { currentPage } from '../common/layout';
import { banners, commentsCountUpdate, loadCommentsNumber, lloadDisqus, disableAdsInEmbedVideo, hitPageView, initCoralComments, coralCommentsEdition, initCoralByCommentsBtnEditions, getCookie, checkAndFilterCoralCommentsAmountToShow, setupScrollOnClick } from '../common/utils/fn';
import { getStroeerGalleryBanners } from '../common/utils/adv-stroeer-mobile-gallery-loader';
// import { getInfinteScroll } from '../common/utils/load-more-loader';
import 'jquery-mousewheel';
import '../common/lightgallery/jquery-lightgallery';
import '../common/lightgallery/jquery-lightgallery-aside';
import '../common/lightgallery/jquery-lightgallery-additional';
import '../common/lightgallery/jquery-lightgallery-topside';
import '../common/lightgallery/jquery-lightgallery-custom-content';
import '../common/msnt/msnt-lightslider.js';
import '../common/lightzoom';
// import 'jquery-scrolltie';
// import { cmpBubbles } from '../common/cmp-bubbles';
import { msntPhotoThumbGallery } from '../common/msnt/msnt-loader';
import { pointsOfInterest } from '../common/widgets/widget-points-of-interest';
import { compareImages } from '../common/widgets/widget-compare-images';
import { faqAccordeon } from '../common/widgets/widget-faq';
import { getNewsletterWidget } from '../common/widgets/widget-newsletter-loader';
import { loadDisqusComments } from '../common/jquery-lazy-load-3rd-party';
import { getStickyVideo } from '../common/utils/sticky-video-loader';
import { topComments } from '../common/top-comments';
// import '../common/jquery-lazy-load-3rd-party';
// import '../common/modernizr';
// import '../common/player';
// import '../common/lazyload.picture';
// import '../common/lot-linx-car';
// import { renderEbay } from '../common/widgets/widget-ebay';
import { throttle, debounce } from 'throttle-debounce';
import { msntConsent } from '../common/msnt-consent';
import '../common/scroll-depth';

currentPage.pageInit = ($page, pageData, pageId) => {
  var $window = $(window),
    $body = $(document.body),
    $page = $('#' + pageId),
    $recommendedBox = $page.find('.recommendedBox'),
    $dataEdtn = $('body').data('edtn'),
    $pageIsRtl = $('body').data('rtl');
    var isVideoArticle = document.querySelector('.videowrapper');
    let cpUserIsLogged = $body.hasClass('cpauthenticated');
    // cpass
    const $contentpassEditions = ['fr', 'ar', 'us', 'it', 'me', 'es', 'uk', 'tr', 'id'];
    var cpAuthhint = getCookie('_cpauthhint');
    let isDevEnv = document.body.classList.contains('development');
    // const contentPassCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH', 'GB', 'UA'];

  // $(
  //   '#article_box .sidebar, #container_3rd_party_service .sidebar'
  // ).stickySidebar({
  //   containerSelector: '.content-area',
  //   limitedScroll: true
  // });
  // cpass
  if (!cpAuthhint) {
    disableAdsInEmbedVideo();
  }

  checkAndFilterCoralCommentsAmountToShow();
  setupScrollOnClick('.m1-article-meta_comments', '#comments');
// cpass

if (!cpAuthhint) {
  topComments.init({
    config: { active: 1 },
  });
}

  msntConsent.initEmbeds($('.postBody'));
  // cpass
  if (cpAuthhint) {
    msntConsent.initEmbedVideo($('.root'));
  }

  msntPhotoThumbGallery().then((api) => {
    api.msntPhotoThumbGallery();
  });

const shareData = {
  title: document.getElementsByClassName('main-article-heading')[0].textContent,
  text: document.getElementsByClassName('sub-article-heading')[0].textContent,
  url: document.location.href,
};

let shareButton = document.getElementsByClassName('m1-article-meta_share')[0];
// console.log(shareButton, window.device.type);
if (shareButton !== null) {
  shareButton.addEventListener("click", async () => {
    if (window.device.type !== 'desktop') {
      gtmDataLayer.push({
        event: 'socialButtonClicked',
      });
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log(err);
      }
    }
  });
}
  

  // var $articlePoster = $('.scrollTieBox');

  // $articlePoster.scrollTie({
  //   property: 'translateY',
  //   delay: function(el) {
  //     return 600;
  //   },
  //   stopAtValue: document.documentElement.clientHeight,
  //   speed: isTouch ? 0.15 : 0.3,
  //   //manualInit: true
  // });

  // let showDisqusButton = document.getElementById('show-disqus');
  // let lloadDisqusEditions = ['ev_us', 'it', 'de', 'fr', 'id', 'ru', 'ev_fr', 'ev_it', 'ev_ru', 'om', 'ra_us', 'ev_br', 'br', 'ra_us'];
  // let isClicked = false;
  // $('.disqus-comment-count, .show-coral').click(function(event) {
  //   isClicked = true;
  //   var showDisqusButton = $('.show-disqus');
  //   var ifVisible = showDisqusButton.data('visible');
  //   let disqusWrapper = document.querySelector('.disqus-wrapper');
  //   let disqusFrameAlreadyExist = false;
  //   if (disqusWrapper) {
  //     let disqusWrapperIframe = disqusWrapper.querySelector('iframe');
  //     if (disqusWrapperIframe && disqusWrapperIframe.id.includes('disqus_comments')) {
  //       disqusFrameAlreadyExist = true;
  //     }
  //   }
    
    
  //   event.preventDefault();
  //   event.stopPropagation();

  //   var anchor;
  //   var commentsElement = $('#comments');
    
  //   if (commentsElement.length) {
  //     anchor = '#' + commentsElement.attr('id');
  //   } else {
  //     var string = $(this).attr('href').split('/');
  //     anchor = string[string.length - 1];
  //   }

  //   var distanceToAnchor = $(anchor).offset().top;
  //   var distanceToAnchorNew;
  //   var callTimes = 0;
  //   let callTimesMax = $dataEdtn === 'ra_us' ? 2 : 6;
  //   let additionalOffset = coralCommentsEdition.includes($dataEdtn) ? -100 : 500;

  //   $('html, body').animate({
  //     scrollTop: $(anchor).offset().top + additionalOffset
  //   }, 500);

  //   const resizeObserver = new ResizeObserver((entries, observer) => {
  //     for(let entry of entries){
  //         if (callTimes < callTimesMax) {
  //           calcResizeTimes();
  //         } else {
  //           resizeObserver.unobserve(document.querySelector('#post_box'));
  //           resizeObserver.unobserve(document.querySelector('#post_sidebar'));
  //           resizeObserver.unobserve(document.querySelector('#container_3rd_party_service'));
  //         }
  //     }
  //   })

  //   resizeObserver.observe(document.querySelector('#post_box'));
  //   resizeObserver.unobserve(document.querySelector('#post_sidebar'));
  //   resizeObserver.observe(document.querySelector('#container_3rd_party_service'));

  //   function calcResizeTimes() {
  //     distanceToAnchorNew = $(anchor).offset().top;

  //     if(distanceToAnchor != distanceToAnchorNew) {
  //       $('html, body').animate({
  //         scrollTop: distanceToAnchorNew + additionalOffset
  //       }, 500);
  //     }
  //     callTimes++;
  //   }

  //   if (lloadDisqusEditions.includes($dataEdtn) && ifVisible && !disqusFrameAlreadyExist) {
  //     if (!coralCommentsEdition.includes($dataEdtn)) {
  //       lloadDisqus();
  //       showDisqusButton.data('visible', false);
  //       showDisqusButton.hide();
  //     } 
  //   }
  // });

  // function scrollingToComments() {
  //   if (isClicked) return;
  //   const targetElement = document.querySelector('#show-disqus');
  //   const distanceToAnchor = targetElement ? targetElement.offsetTop : 0;

  //   if (window.location.hash === '#m1-top-comments__wrapper' && targetElement) {
  //     let callTimes = 0;
  //     let callTimesMax = $dataEdtn === 'ra_us' ? 2 : 6;
  //     const resizeObserver = new ResizeObserver((entries, observer) => {
  //       for(let entry of entries){
  //           if (callTimes < callTimesMax) {
  //             calcResizeTimes();
  //           } else {
  //             resizeObserver.unobserve(document.querySelector('#post_box'));
  //             resizeObserver.unobserve(document.querySelector('#post_sidebar'));
  //             resizeObserver.unobserve(document.querySelector('#container_3rd_party_service'));
  //           }
  //       }
  //     })
  
  //     resizeObserver.observe(document.querySelector('#post_box'));
  //     resizeObserver.unobserve(document.querySelector('#post_sidebar'));
  //     resizeObserver.observe(document.querySelector('#container_3rd_party_service'));
  //     const distanceToAnchorNew = targetElement.offsetTop;

  //     function calcResizeTimes() {
  //       if(distanceToAnchor != distanceToAnchorNew) {
  //         $('html, body').animate({
  //           scrollTop: distanceToAnchorNew + 300
  //         }, 500);
  //       }
  //       callTimes++;
  //     }
  //   }
  // }

  window.addEventListener('message', function(e){
    let data = e.data;
    if (data === 'newComment') {
      gtmDataLayer.push({
        event: data,
      });
    }
  })

  // scrollingToComments();
  pointsOfInterest();
  compareImages();
  faqAccordeon();
  // if (adplayer && typeof adplayer.init === 'function') {
  // 	adplayer.init();
  // }

  // cmpBubbles.init({
  //   minWidth: 640,
  //   error: function(data, element, response, textStatus, jqXHR) {
  //     cmpTrayAlert.show(
  //       jqXHR.responseJSON &&
  //       jqXHR.responseJSON.constructor === Object &&
  //       jqXHR.responseJSON.message
  //         ? jqXHR.responseJSON.message
  //         : 'Bad response (JSON)',
  //       'error',
  //       30
  //     );
  //   },
  // });

  function adjustFacebookVideoWrapper() {
    let facebookWrapper = document.getElementsByClassName('facebook-video-wrapper')[0];
  
    if (facebookWrapper) {
      let fbSizer = facebookWrapper.querySelector('.sizer');
      let videoIframe = facebookWrapper.querySelector('iframe');
  
      let fbSizerHeight = fbSizer.offsetHeight;
      let videoIframeWidth = videoIframe.getAttribute('width');
      let videoIframeHeight = videoIframe.getAttribute('height');
      let iframeAspectRatio = videoIframeHeight / videoIframeWidth;
  
      if (iframeAspectRatio === 1) {
        videoIframe.height = fbSizerHeight;
        videoIframe.width = fbSizerHeight;
      } else if (iframeAspectRatio === 0.5625) {
        facebookWrapper.classList.add('facebook-iframe-sizer');
      } else if (iframeAspectRatio > 1) {
        videoIframe.height = fbSizerHeight;
        videoIframe.width = fbSizerHeight / iframeAspectRatio;
      } else {
        videoIframe.height = fbSizerHeight;
        facebookWrapper.classList.add('facebook-iframe-sizer');
      }
    }
  }
  
  adjustFacebookVideoWrapper();


  if (isVideoArticle != null) {
    getStickyVideo().then((api) => {
      api.stickyVideo($dataEdtn, $window);
    });
  }

  if ($dataEdtn == 'de' || $dataEdtn == 'ev_de' && !cpAuthhint) {
    getStroeerGalleryBanners().then((api) => {
      api.initDeMobileGalleryBanners();
    });
  }

  if ($dataEdtn == 'us' || $dataEdtn == 'ra_us' || $dataEdtn == 'ev_us') {
    const headerRequest = new Request(document.location);
    fetch(headerRequest).then((response) => {
      const headerTitle = "Geoip-Country";
      if(response.headers.has(headerTitle)){
        var title = response.headers.get(headerTitle);
        gtmDataLayer.push({
          event: 'geoIpIsPresent',
          'userGeoIp': title
        });
      }
    });
  }

  function initializeLightzoom() {
    if ($('.lightzoom').length > 0) {
      $( '.lightzoom' ).lightzoom({
        speed:                 100,   // скорость появления
        imgPadding:            1,    // значение отступа у изображения
        overlayOpacity:        '0.5', // прозрачность фона (от 0 до 1)
        viewTitle:             false, // true, если надо показывать подпись к изобажению
        isOverlayClickClosing: true, // true, если надо закрывать окно при клике по затемненной области
        isWindowClickClosing:  true, // true, если надо закрывать окно при клике по любой области
        isEscClosing:          true, // true, если надо закрывать окно при нажатии на кнопку Esc
        boxClass:              '',    // позволяет задавать класс окну обертке (с версии 1.1.0)
        overlayColor:          '',    // позволяет задавать цвет фону (с версии 1.1.0)
        titleColor:            '',    // позволяет задавать цвет подписи (с версии 1.1.0)
      });
    }
  }

  initializeLightzoom();

  //let ebayWrapper = document.querySelector('.ebay-widget');

  // if ($dataEdtn == 'it' && ebayWrapper) {
  //   renderEbay();
  // }

  // function dataSrcReplacer() {
  //   console.log('helloworld');
  //   var vidDefer = document.getElementsByTagName('iframe');
  //   console.log(vidDefer);
  //   for (var i=0; i<vidDefer.length; i++) {
  //     if(vidDefer[i].getAttribute('data-src')) {
  //        vidDefer[i].setAttribute('src',vidDefer[i].getAttribute('data-src'));
  //     }
  //   }
  // }

  // window.onload = dataSrcReplacer;
  // $('.author-js-link').on('click', function () {
  //   window.location.href = $(this).data('href');
  // });

  // DEV: Section Pages: html and css structure for Pagination
  // const setIframeModifier = function () {
  //   const embedItems = document.querySelectorAll('.embed-item');
  //   if (embedItems.length === 0) {
  //     return;
  //   }
  //   return [...embedItems].map((item) => {
  //     const itemEl = item.firstElementChild;
  //     if (itemEl.nodeName === 'IFRAME') {
  //       const itemSrc = itemEl.getAttribute('src');
  //       const itemHeight = itemEl.getAttribute('height');
  //       const itemWidth = itemEl.getAttribute('width');
  //       const iframeAspectRatio = itemHeight/itemWidth;
  //       if (iframeAspectRatio === 1 && itemSrc.includes('facebook.com/plugins')) {
  //         item.classList.add('embed-item_fb');
  //       }
  //     }
  //   });
  // };

  // window.addEventListener('load', setIframeModifier);

  // let embedItems = document.querySelectorAll('.embed-item');
  // console.log(embedItems);
  // if(embedItems.length) {
  //   const config = {
  //     attributes: true,
  //     childList: true,
  //     subtree: true
  //   };

  //   const callback = function(mutationsList, observer) {
  //     // console.log('called');
  //     for (let mutation of mutationsList) {
  //         if (mutation.type === 'childList' ||  mutation.type === 'subtree') {
  //             console.log(mutation.target);
  //             console.log('A child node has been added or removed.');
  //         }
  //     }
  //   };

  //   const observer = new MutationObserver(callback);

  //   for (let embedItem of embedItems) {

  //     if (embedItem.innerHTML !== '') {
  //       console.log(embedItem.innerHTML);
  //       return;
  //     }
  //     observer.observe(embedItem, config);
  //   }
  // }

  // getNewsletterWidget().then((api) => {
  //   api.newsletter();
  // });
  // if (infiniteScrollEdtn.includes($dataEdtn)) {
  //   const comentsCounter = document.querySelector('.disqus-comment-count');
  //   const commentsContainer = document.querySelector('.comments-container');
  //   comentsCounter.remove();
  //   commentsContainer.remove();
  // } else {
  //   commentsCountUpdate();
  //   loadDisqusComments();
  // }

  // if (!infiniteScrollEdtn.includes($dataEdtn) && !cpAuthhint) {
  //   commentsCountUpdate();
  //   loadDisqusComments();
  // }
  //cpass
  if (($dataEdtn == 'ev_ar'  && !cpAuthhint) || $dataEdtn == 'br' || ($dataEdtn == 'ar' && !cpAuthhint)) {
    commentsCountUpdate();
    loadDisqusComments();
  }

  // commentsCountUpdate();
  // loadDisqusComments();

  //bannerLazyload();
  // if (!coralCommentsEdition.includes($dataEdtn)) loadCommentsNumber();
  if (!coralCommentsEdition.includes($dataEdtn) && !cpAuthhint) loadCommentsNumber();
  const coralContainer = $('#coral_thread');
  const showCoralCommentsBtn = document.querySelector('#show-disqus');
  // const showCoralCommentsBtnTopComments = document.querySelector('.m1-top-comments__empty > span');
  const topCommentsEmptyBlock = document.querySelector('.m1-top-comments');

  if (coralCommentsEdition.includes($dataEdtn) && initCoralByCommentsBtnEditions.includes($dataEdtn) && coralContainer.length) {
    showCoralCommentsBtn.addEventListener('click', (e) => {
      e.preventDefault();
      initCoralComments();
      if (showCoralCommentsBtn && topCommentsEmptyBlock) {
        showCoralCommentsBtn.remove();
        topCommentsEmptyBlock.remove();
      }
    });
    // if (showCoralCommentsBtnTopComments) {
    //   showCoralCommentsBtnTopComments.addEventListener('click', () => {
    //     initCoralComments();
    //     showCoralCommentsBtn.remove();
    //     topCommentsEmptyBlock.remove();
    //   });
    // }
  } else if (coralCommentsEdition.includes($dataEdtn) && coralContainer.length) {
    initCoralComments();
  }
  $('.photo-title a').on('click', function(e) {
    e.stopPropagation();
  });
  
  // function initializeAuthorSocials() {
  //   const authorSocialsItems = document.querySelectorAll('.author-socials-item');
  
  //   if (authorSocialsItems.length > 0) {
  //     authorSocialsItems.forEach((item) => {
  //       item.addEventListener('click', handleAuthorSocialsClick);
  //     });
  //   }
  // }
  
  // function handleAuthorSocialsClick(event) {
  //   const outlink = event.currentTarget.dataset.outlink;
  //   const decodedOutlink = new TextDecoder('utf-8').decode(Uint8Array.from(atob(outlink), c => c.charCodeAt(0)));
  //   window.open(decodedOutlink, '_blank');
  // }
  
  // initializeAuthorSocials();
  

  if($dataEdtn === 'de' || $dataEdtn === 'ev_de') {
    const trendingWrapper = document.querySelector('.trending-content');
    const outbrainWrapper = document.querySelector('.outbrain_service');
    if(!!trendingWrapper && !!outbrainWrapper && window.innerWidth <= 1023) {
      const parentElement = outbrainWrapper.parentNode;
      parentElement.insertAdjacentElement('afterend', trendingWrapper);
    }
  }

// Infinite sroll functionality article
// var abCookie = getCookie('abtest');
// if (infiniteScrollEdtn.includes($dataEdtn)) {
//   if ($dataEdtn !== 'it' || ($dataEdtn == 'it' && (abCookie == 'Auto-v1.3' || abCookie == 'Auto-v1.4'))) {
//     getInfinteScroll().then((api) => {
//       api.loadMorePages(adjustFacebookVideoWrapper, shareTrend, handleHideAsideScroll, setupCompetitorsSlider, isVideoArticle, getStickyVideo, $dataEdtn, infiniteScrollEdtn, $window, initializeAuthorSocials, initializeLightzoom, disableAdsInEmbedVideo, pointsOfInterest, compareImages, faqAccordeon, msntPhotoThumbGallery, getM1FindVehicleEu, getM1FindVehicleUs, getM1FindVehicleByType, cmpBubbles, oneTrust);
//     });
//   }  
// }
// Infinite article sroll functionality

  getNewsletterWidget().then((api) => {
    api.newsletter();
  });

  function setSidebarTopPosition() {
    const trendingWidget = document.querySelector('.trending-content');
    const scrollSidebar = document.querySelector('.m1-newsfeed_sidebar-wrapper');
    const bodyTag = document.querySelector('body');
    
    let trendingWidgetHeight;
    if (trendingWidget) {
      trendingWidgetHeight = trendingWidget.offsetHeight;
    }
    
    let headerHeight = 221;
    const contentBeforeHeight = 638;
  
    if (bodyTag.classList.contains('no-rect-strip')) {
      headerHeight = 83;
    }
  
    const paddingNum = (trendingWidgetHeight + contentBeforeHeight) - headerHeight;
  
    if (scrollSidebar) {
      scrollSidebar.style.top = `-${paddingNum}px`;
    }
  }
  
  if ($dataEdtn != 'de' && $dataEdtn != 'ev_de' && !cpAuthhint) {
    let resizeTimeout;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        setSidebarTopPosition();
      }, 300);
    });
    setSidebarTopPosition();
  }
};